import { createAsyncThunk } from '@reduxjs/toolkit';
import { _aiServiceUrls } from '@custom/Utils/constants/apiUrls';

const predictFractureApi = createAsyncThunk(
  'predictFractureApi',
  async (reportId: string) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${_aiServiceUrls.XRAYBone}/${reportId}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch report details');
      }

      return await response.json();
    } catch (error) {
      return Promise.reject(error);
    }
  }
);

export default predictFractureApi;
